import React, { Component } from 'react';
import { render } from 'react-dom';
import WMThemeProvider from '@workmarket/front-end-components/dist/common/WMThemeProvider';
import Navigation from './components/Navigation';
import ajaxSendInit from '../funcs/ajaxSendInit';
import translate from '../funcs/translation';
import userInfo from '../core/user_info';
import wmFetch from '../funcs/wmFetch';
import wmNotify from '../funcs/wmNotify';
import ShellNavigation from "./components/WaypointShellNav/ShellNavigation";

if (document.querySelector('meta[name="isDesktop"]').getAttribute('content') === 'true') {
	// fix for ajax requests on components
	ajaxSendInit();

	const loadConfig = () => {
		// from /partials/navigation/app.jsp
		const navConfig = window.navConfig;
		const isBuyer = navConfig.currentUser.buyer;
		const isSellerOrgPayNavigation = navConfig.currentUser.isSellerOrgPayNavigation;
		const isBuyerOrgPayNavigation = navConfig.currentUser.isBuyerOrgPayNavigation;
		const canRedirectToBuyerHome = navConfig.currentUser.canRedirectToBuyerHome;
		const canRedirectToSellerHome = navConfig.currentUser.canRedirectToSellerHome;

		let homePageLink = canRedirectToBuyerHome
			? "/home/company"
			: canRedirectToSellerHome
				? "/my-home"
				: "/home";

		const homeNavItem = {
			label: translate("translation.home"),
			iconPath: 'M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z',
			href: homePageLink,
		};

		if (isBuyer) {
			navConfig.navMenuItems = [
				{
					label: translate("translation.work"),
					iconPath: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z',
					items: [
						{ href: '/assignments/', title: translate("translation.assignments") },
						{ href: '/projects', title: translate("translation.projects") },
						{ href: '/addressbook', title: translate("translation.contact_manager") },
						{ href: '/assignments/upload', title: translate("translation.work_upload_tm") },
						{ href: '/realtime', title: translate("translation.realtime") }
					]
				},
				{
					label: translate("translation.talent"),
					iconPath: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z',
					items: [
						{ href: '/talent', title: translate("translation.find_talent") },
						{ href: '/labor-clouds', title: translate("translation.talent_pools") },
						{ href: '/recruiting', title: translate("translation.recruiting") },
						{ href: '/lms/manage/list_view', title: translate("translation.tests") },
						{ href: '/lms/manage/surveys', title: translate("translation.surveys") }
					]
				}];

			if (navConfig.hasCreateWork) {
				if (navConfig.useNewCreateWork) {
					navConfig.navMenuItems[0].items.splice(1, 0,
						{ href: '/manage/create', title: translate("translation.new_assignment") });
				} else {
					navConfig.navMenuItems[0].items.splice(1, 0,
						{ href: '/assignments/?launchAssignmentModal&introdisabled', title: translate("translation.new_assignment") });
				}
			}

			if(navConfig.hasOrgStructureFeatureEnabled) {
				const orgStructureItem = {
					label: translate("translation.orgstructure"),
					iconPath: 'M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z',
					href: '/org-structure',
					style: 'useOverwriteStyles'
				};
				navConfig.navMenuItems.unshift(orgStructureItem);
			}

			if (isBuyerOrgPayNavigation) {
				navConfig.navMenuItems.splice(0, 1); // Remove the "Work" nav menu item for Org Pay Clients
			}

			const payItems = [
				{ href: navConfig.hasImpoundDisbursementEnabled ? '/payments/invoices/payables' : '/payments',
					title: translate(navConfig.hasImpoundDisbursementEnabled ? "translation.invoices" : "translation.overview") }
			];

			if (navConfig.pay) {
				payItems.push(
                    { href: '/pay', title: translate("translation.requests")}
                );
            }

			if (navConfig.hasImpoundDisbursementEnabled) {
				payItems.push(
					{ href: '/accounts', title: translate("translation.accounts") }
				);
			} else {
				if (navConfig.hasAdpTrustAddFundsFeature) {
					if (navConfig.clientCanViewAddFundsInMenu) {
						payItems.push(
							{href: '/funds/add', title: translate("translation.add_funds")},
							{
								href: '/accounts', title: translate("translation.accounts")
							});
					} else {
						payItems.push(
							{
								href: '/accounts', title: translate("translation.accounts")
							});
					}
				} else {
					payItems.push(
						{href: '/funds/add', title: translate("translation.add_funds")},
						{
							href: '/accounts', title: translate("translation.accounts")
						});
				}
			}

			if (isBuyerOrgPayNavigation && navConfig.hasOmpClientHomepageProjectAndContactManagerFeature) {
				payItems.push(
					{ href: '/projects', title: translate("translation.projects") },
					{ href: '/addressbook', title: translate("translation.contact_manager") },
				);
			}

			navConfig.navMenuItems.push({
                 label: translate("translation.payments"),
                 iconPath: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z',
                 items: payItems

			});

			const reportItems = [];
			if (navConfig.hasViewCompanyAnalyticsDashboardPermission) {
				reportItems.push({href: '/analytics-dashboards', title: translate("translation.analytics_dashboards")});
			}
			if (navConfig.hasReportingPermissions || navConfig.hasAdvancedReportingPermissions) {
				reportItems.push(
					{ href: '/custom-reports', title: translate('translation.custom_reports') }
				);
			}

			if(reportItems && reportItems.length) {
				const reportLabel = "translation.analytics";
				navConfig.navMenuItems.push({
					label: translate(reportLabel),
					iconPath: 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z',
					items: reportItems
				});
			}
		} else {
			navConfig.navMenuItems = isSellerOrgPayNavigation
				? [
					{
						label: translate("translation.talent_profile_op"),
						iconPath: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
						items: [
							{href: '/profile', title: translate("translation.my_profile_op")},
							{href: '/account/tax', title: translate("translation.tax_info")},
						]
					},
					{
						label: translate("translation.payments"),
						iconPath: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z',
						items: [
							{href: '/payments', title: translate("translation.overview")},
							{href: '/accounts', title: translate("translation.accounts")}
						]
					}
				]
				: [
					{
						label: translate("translation.talent_profile"),
						iconPath: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
						items: [
							{href: '/profile', title: translate("translation.my_profile")},
							{href: '/lms/view', title: translate("translation.tests")},
							{href: '/search-groups', title: translate("translation.talent_pools")}
						]
					},
					{
						label: translate("translation.work"),
						iconPath: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z',
						items: [
							{href: '/assignments', title: translate("translation.my_work")},
							{href: '/worker/browse', title: translate("translation.find_work")},
							{href: '/assignments?calendar=on', title: translate("translation.calendar")},
							{href: '/ratings', title: translate("translation.ratings")}
						]
					},
					{
						label: translate("translation.payments"),
						iconPath: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z',
						items: [
							{href: '/payments', title: translate("translation.overview")},
							{href: '/accounts', title: translate("translation.accounts")}
						]
					}
				];

			if (!isSellerOrgPayNavigation) {
				const reportItems = [];
				if (navConfig.canViewMyReports) {
					reportItems.push(
						{href: '/custom-reports', title: translate('translation.custom_reports')}
					);
				}

				if (reportItems && reportItems.length) {
					const reportLabel = "translation.analytics";
					navConfig.navMenuItems.push({
						label: translate(reportLabel),
						iconPath: 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z',
						items: reportItems
					});
				}
			}
		}

		// Add the home item at the beginning of the nav menu items
		if (navConfig.hasWaypointSquirtleShellFeature) {
			navConfig.navMenuItems.unshift(homeNavItem);
		}

		if (userInfo.isSupport) {
			const logoutItem = navConfig.currentUser.userMenu.find(it => it.href && it.href.startsWith('/logout'));
			if (logoutItem) {
				logoutItem.title = 'End Session';
				logoutItem.href = null;
				logoutItem.action = () => {
					wmFetch('/v3/authSession/authSwitch/end-support-session').then((payload) => {
						const [{ companyId }] = payload;
						const adminSupportPage = `/admin/manage/company/customer_support/${companyId}`;
						window.location.href = adminSupportPage;
					}).catch((error) => {
						wmNotify({
							message: error,
							type: 'danger'
						});
					});
				};
			}
		}

		return navConfig;
	};

	const toKebabCase = str =>
		str && str
			.replace(/([a-z])([A-Z])/g, '$1-$2')
			.replace(/[\s_]+/g, '-')
			.toLowerCase();

	const mapIcon = label => {
		// Map section labels to icon names as needed
		const iconMap = {
			account: 'user',
			analytics: 'ext-mdi-show-chart',
			home: 'home',
			'organizational-structures': 'action-view-settings',
			payments: 'institution-bank',
			reports: 'ext-mdi-show-chart',
			talent: 'user-group',
			'talent profile': 'user',
			work: 'work',
			'Assignments': 'work',
		};
		return iconMap[toKebabCase(label)] || 'user';
	};

	const mapToNewMenuFormat = menuFromBE => {
		return menuFromBE.map(section => ({
			id: toKebabCase(section.label),
			title: section.label,
			hash: section.href || null,
			icon: mapIcon(section.label),
			hasChildren: Array.isArray(section.items) && section.items.length > 0,
			children: (section.items || []).map(child => ({
				id: toKebabCase(child.title),
				title: child.title,
				hash: child.href,
			})),
		}));
	};

	const config = loadConfig();

	class NavigationApp extends Component {
		render() {
			return config.hasWaypointSquirtleShellFeature ? (
				<ShellNavigation
					showSupportBanner={userInfo.isSupport}
					newConfig={{
						...config,
						navMenuItems: mapToNewMenuFormat(config.navMenuItems),
					}}
				/>
			) : (
				<WMThemeProvider>
					<Navigation
						config={config}
						showSupportBanner={userInfo.isSupport}
					/>
				</WMThemeProvider>
			);
		}
	}

	const renderApp = () => {
		render(<NavigationApp />, document.querySelector('#wm-main-nav'));
	};

	if (config.hasWaypointSquirtleShellFeature) {
		if (!window.SynergConfig) {
			console.error('SynergConfig is missing');
		} else {
			initializeSynergConfig();
			renderApp();
		}
	} else {
		renderApp();
	}
}



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/mainNav/index.js